module.exports = __webpack_public_path__ + "static/assets/150503fb4db3881f43e910d8ad01a660.png";